import React from 'react';
import classNames from 'classnames';

import css from './SectionSteps.module.css';

/** Aus '01' wird nicht mehr als eine Ziffernfolge - zweistellig sieht ruhiger aus. */
const nummer = index => String(index + 1).padStart(2, '0');

/**
 * Am Ende der Linie steht, was als Nächstes kommt: ein Pfeil, solange es
 * weitergeht, und ein Haken beim letzten Schritt.
 */
const Marke = ({ fertig }) => (
  <svg
    className={css.marker}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    aria-hidden="true"
    focusable="false"
  >
    {fertig ? (
      <path
        d="M3.5 8.4 6.6 11.5 12.5 4.9"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    ) : (
      <path
        d="M2.5 8h9M8.4 4.6 11.8 8l-3.4 3.4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);

/**
 * FairwayBid: Der Ablauf als nummerierte Strecke.
 *
 * Eigener Baustein, weil ihn zwei Seiten brauchen: die Startseite mit dem
 * Ablauf aus der Console und die Händlerseite mit ihrem eigenen. Beide
 * sollen gleich aussehen - eine Kopie waere in einem halben Jahr eine
 * abweichende Kopie.
 *
 * @param {Array<{title: string, text: string}>} steps
 * @param {boolean} onDark  steht der Abschnitt auf dunklem Grund?
 */
const StepList = ({ steps = [], onDark = false, className }) => (
  <ol className={classNames(css.steps, { [css.onDark]: onDark }, className)}>
    {steps.map((step, i) => {
      const istLetzter = i === steps.length - 1;
      return (
        <li key={step.title || i} className={css.step}>
          <div className={css.head}>
            <span className={css.badge} aria-hidden="true">
              {nummer(i)}
            </span>
            <span className={classNames(css.railWrap, { [css.railWrapLast]: istLetzter })}>
              <span className={css.railLine} aria-hidden="true" />
              <Marke fertig={istLetzter} />
            </span>
          </div>
          <h3 className={css.title}>{step.title}</h3>
          <p className={css.text}>{step.text}</p>
        </li>
      );
    })}
  </ol>
);

export default StepList;
